import type { SxProps, Theme } from '@mui/material/styles';

/** Solid FloAI primary CTA — no purple/blue gradients (matches MUI contained primary). */
export function marketingPrimaryCtaSx(extra?: SxProps<Theme>): SxProps<Theme> {
  const base = {
    bgcolor: 'primary.main',
    color: 'primary.contrastText',
    borderRadius: 6,
    fontWeight: 600,
    textTransform: 'none' as const,
    boxShadow: (theme: Theme) => `0 2px 12px ${theme.palette.primary.main}33`,
    '&:hover': {
      bgcolor: 'primary.dark',
      boxShadow: (theme: Theme) => `0 2px 12px ${theme.palette.primary.main}44`,
    },
  };
  return extra ? ([base, extra] as SxProps<Theme>) : (base as SxProps<Theme>);
}

/** Highlighted pricing / promo band — solid primary, not gradient. */
export function marketingPrimaryBandSx(): SxProps<Theme> {
  return {
    bgcolor: 'primary.main',
    borderRadius: 1,
  };
}
